<div class="packages-container">
    <p-toast></p-toast>
    <p-confirmDialog [style]="{width: '450px'}" styleClass="delete-confirm-dialog"></p-confirmDialog>
    <div *ngIf="!isLoading">
        <div class="header-section">
            <div class="title-group">
                <h1>Service Packages</h1>
                <p>Manage your service offerings</p>
            </div>
            <button pButton type="button" label="Add Package" icon="pi pi-plus" (click)="addPackage()"
                class="p-button-raised add-package-btn">
            </button>
        </div>

        <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2 mb-5">
            <div class="flex align-items-center justify-content-between">
                <h2 class="text-left font-medium text-2xl" style="color: #303030;">Search</h2>
            </div>
            <form [formGroup]="filterForm" (ngSubmit)="onSearch()" class="w-full flex flex-wrap align-items-center">
                <div class="w-full grid">
                    <div class="col-12 sm:col-6 md:col-4 xl:col-4
                 flex flex-column gap-2">
                        <b class="font-regular text-base" style="color: #505050;">Package Name</b>
                        <p-autoComplete placeholder="Name" formControlName="name" [suggestions]="names" class="w-full"
                            [style]="{'width': '100%'}" [inputStyle]="{'width': '100%'}"
                            (completeMethod)="filterNames($event)" styleClass="fullWidth" field="name" [minLength]="3"
                            appendTo="body">
                        </p-autoComplete>
                    </div>

                    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
                        <b class="font-regular text-base" style="color: #505050;">Status</b>
                        <p-dropdown [options]="stateOptions" [showClear]="true" optionValue="value"
                            styleClass="selectFull" [style]="{'width': '100%'}" formControlName="packageState"
                            optionLabel="name" class="w-full" placeholder="Active/Inactive" />
                    </div>


                    <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
                        <div style="padding-top: 23px;">
                            <p-button type="submit" label="Search" styleClass="submitBtn"
                                [style]="{'background-color': '#000086', 'border': 'none', 'box-shadow': 'none', 'outline': 'none'}" />
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div style="position: relative; min-height: 200px;">
            <div *ngIf="isSearchLoading" class="flex align-items-center justify-content-center"
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255, 255, 255, 0.7); z-index: 10; backdrop-filter: blur(2px);">
                <i class="pi pi-spin pi-spinner" style="font-size: 3rem; color: #303030;"></i>
            </div>

            <div class="packages-grid" *ngIf="filteredPackages().length > 0; else noRecordsFound">
                <div class="package-card" *ngFor="let pkg of filteredPackages()">
                    <div class="card-header">
                        <h3>{{ pkg.name }}</h3>
                        <div class="flex align-items-center gap-2">
                            <span *ngIf="pkg.isReadOnly" class="status-badge"
                                style="background: #e8eaf6; color: #000086;"
                                pTooltip="Fixed package — name and price can only be changed by the technical team"
                                tooltipPosition="top">
                                <i class="pi pi-lock" style="font-size: 0.75rem; margin-right: 4px;"></i>FIXED
                            </span>
                            <span class="status-badge" [class.active]="pkg.status === 'Active'">
                                {{ pkg.status }}
                            </span>
                        </div>
                    </div>
                    <div class="text-sm font-medium mb-2" style="color: #6c757d;">
                        <i class="pi pi-tag" style="font-size: 0.875rem; margin-right: 4px;"></i>
                        <span>{{ getCategoryNames(pkg.categories) }}</span>
                    </div>

                    <div class="description" [innerHTML]="pkg.description"></div>

                    <div class="duration">
                        <i class="pi pi-clock"></i>
                        <span>{{ pkg.duration }} {{ pkg.durationType === 1 ? (pkg.duration == 1 ? 'Day' : 'Days') :
                            (pkg.duration == 1 ? 'Month' : 'Months') }}</span>
                    </div>

                    <div class="services-list">
                        <span class="list-title">Services Included:</span>
                        <ul>
                            <li *ngFor="let service of pkg.servicesIncluded">
                                <i class="pi pi-check-circle"></i>
                                <span>{{ service }}</span>
                            </li>
                        </ul>
                    </div>

                    <div class="card-footer">
                        <span class="price">
                            {{ pkg.currency }}{{ pkg.amount | number }}
                            <small style="font-size: 0.75rem; font-weight: 500; color: #6c757d;">+ GST</small>
                        </span>
                        <div class="actions">
                            <button *ngIf="!pkg.isReadOnly" pButton type="button"
                                [icon]="pkg.status === 'Active' ? 'pi pi-times' : 'pi pi-check'"
                                (click)="toggleStatus(pkg)"
                                [pTooltip]="pkg.status === 'Active' ? 'Deactivate Package' : 'Activate Package'"
                                tooltipPosition="top" class="p-button-text p-button-rounded"
                                [ngClass]="pkg.status === 'Active' ? 'p-button-danger' : 'p-button-success'">
                            </button>
                            <button pButton type="button" icon="pi pi-copy" (click)="copyPaymentLink(pkg)"
                                pTooltip="Copy Payment Link" tooltipPosition="top"
                                class="p-button-text p-button-rounded p-button-info">
                            </button>
                            <!-- <button pButton type="button" icon="pi pi-lock" label="Fixed"
                                pTooltip="Package is Fixed and can only be changed from the backend"
                                tooltipPosition="top" class="p-button-text p-button-rounded p-button-secondary"
                                disabled>
                            </button> -->
                            <button pButton type="button" icon="pi pi-pencil" (click)="editPackage(pkg)"
                                pTooltip="Edit Package" tooltipPosition="top"
                                class="p-button-text p-button-rounded p-button-secondary">
                            </button>
                            <button pButton type="button" icon="pi pi-trash" (click)="deletePackage(pkg)"
                                pTooltip="Delete Package" tooltipPosition="top"
                                class="p-button-text p-button-rounded p-button-danger">
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <ng-template #noRecordsFound>
                <div class="w-full flex flex-column align-items-center py-4 gap-5">
                    <div class="w-full flex align-items-center justify-content-center">
                        <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
                    </div>
                    <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
                </div>
            </ng-template>
        </div>
    </div>
    <div *ngIf="isLoading" class="flex gap-4 align-items-center justify-content-center py-5">
        <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" fill="var(--surface-ground)"
            animationDuration=".5s"></p-progressSpinner>
    </div>
</div>

<p-dialog [(visible)]="displayDialog" [header]="isEditMode ? 'Edit Package' : 'Add New Package'" [modal]="true"
    [style]="{width: '1000px'}" [draggable]="false" [resizable]="false" [closable]="true" [closeOnEscape]="true"
    styleClass="add-package-modal">

    <form [formGroup]="packageForm">
        <div class="dialog-content">
            <!-- Left Column: Standard Fields -->
            <div class="left-section flex-1">
                <div class="field">
                    <label for="packageName">Package Name <span class="required">*</span></label>
                    <input id="packageName" type="text" pInputText formControlName="name"
                        placeholder="Enter package name" [readonly]="isEditMode && packageForm.get('isReadOnly')?.value"
                        class="w-full" [ngClass]="{'ng-invalid ng-dirty': name?.invalid,
                'surface-200 text-600 cursor-not-allowed': isEditMode && packageForm.get('isReadOnly')?.value}">
                    <small class="p-error" *ngIf="name?.errors?.['required']">
                        Package name is required
                    </small>
                    <small class="p-error" *ngIf="name?.errors?.['minlength']">
                        Package name must be at least 3 characters
                    </small>
                    <small *ngIf="isEditMode && packageForm.get('isReadOnly')?.value" class="text-500 block mt-1">
                        <i class="pi pi-lock text-xs"></i> Fixed package — name cannot be changed.
                    </small>
                </div>

                <div class="field">
                    <label for="categories">Categories <span class="required">*</span></label>
                    <p-multiSelect id="categories" [options]="categoryOptions" formControlName="categories"
                        optionLabel="label" optionValue="value" placeholder="Select Categories" display="chip"
                        styleClass="w-full" class="w-full"
                        [ngClass]="{'ng-invalid ng-dirty': (formSubmitted || categories?.touched) && categories?.invalid}">
                    </p-multiSelect>
                    <small class="p-error"
                        *ngIf="(formSubmitted || categories?.touched) && categories?.errors?.['required']">
                        At least one category is required
                    </small>
                </div>

                <div class="field-row">
                    <div class="field field-half">
                        <label for="duration">Duration & Type <span class="required">*</span></label>
                        <div class="flex gap-2">
                            <input id="duration" type="number" pInputText formControlName="duration"
                                placeholder="Duration" class="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': (formSubmitted || duration?.touched) && duration?.invalid}">
                            <p-dropdown id="durationType" [options]="durationTypeOptions" formControlName="durationType"
                                optionLabel="label" optionValue="value" styleClass="w-full" class="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': (formSubmitted || durationType?.touched) && durationType?.invalid}">
                            </p-dropdown>
                        </div>
                        <small class="p-error block"
                            *ngIf="(formSubmitted || duration?.touched) && duration?.errors?.['required']">
                            Duration is required
                        </small>
                        <small class="p-error block"
                            *ngIf="(formSubmitted || duration?.touched) && duration?.errors?.['min']">
                            Duration must be at least 1
                        </small>
                        <small class="p-error block"
                            *ngIf="(formSubmitted || durationType?.touched) && durationType?.errors?.['required']">
                            Duration type is required
                        </small>
                    </div>

                    <div class="field field-half">
                        <label for="price">Amount <span class="required">*</span></label>
                        <p-inputNumber id="price" formControlName="amount" mode="currency" currency="INR" locale="en-IN"
                            [readonly]="isEditMode && packageForm.get('isReadOnly')?.value"
                            [style]="{'width': '100%'}" [ngClass]="{'ng-invalid ng-dirty': amount?.invalid}">
                        </p-inputNumber>
                        <small *ngIf="isEditMode && packageForm.get('isReadOnly')?.value" class="text-500 block mt-1">
                            <i class="pi pi-lock text-xs"></i> Fixed package — price cannot be changed.
                        </small>
                        <small class="p-error" *ngIf="amount?.errors?.['required']">
                            Amount is required
                        </small>
                        <small class="p-error" *ngIf="amount?.errors?.['min']">
                            Amount must be greater than 0
                        </small>
                    </div>
                </div>

                <div class="field">
                    <label for="services">Services Offered <span class="required">*</span></label>
                    <p-chips id="services" formControlName="servicesIncluded"
                        placeholder="Type and press Enter to add services"
                        [ngClass]="{'ng-invalid ng-dirty': formSubmitted && servicesIncluded?.invalid}">
                    </p-chips>
                    <small class="field-hint">Press Enter after each service to add it</small>
                    <small class="p-error" *ngIf="formSubmitted && servicesIncluded?.errors?.['required']">
                        At least one service is required
                    </small>
                </div>
            </div>

            <!-- Right Column: Description Editor -->
            <div class="right-section flex-1" style="position: relative; min-height: 400px;">
                <div class="field flex flex-column mb-0 w-full"
                    style="position: absolute; top: 0; bottom: 0; left: 0; right: 0;">
                    <label for="description" class="flex-none">Description <span class="required">*</span></label>
                    <div class="flex-1 w-full" style="position: relative;">
                        <div style="position: absolute; top: 0; left: 0; bottom: 0; right: 0;">
                            <app-content-editor [htmlContent]="packageForm.get('description')?.value"
                                [style]="{ height: '100%' }"
                                (onContentChange)="onDescriptionChange($event)"></app-content-editor>
                        </div>
                    </div>
                    <small class="p-error flex-none" *ngIf="formSubmitted && description?.errors?.['required']">
                        Description is required
                    </small>
                    <small class="p-error flex-none" *ngIf="formSubmitted && description?.errors?.['minlength']">
                        Description must be at least 5 characters
                    </small>
                </div>
            </div>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <div class="dialog-footer">
            <button pButton type="button" label="Cancel" icon="pi pi-times" (click)="cancelDialog()"
                class="p-button-text">
            </button>
            <button pButton type="button" [label]="isEditMode ? 'Update' : 'Save'" icon="pi pi-check"
                (click)="savePackage()" [disabled]="!isFormValid()" class="p-button-raised">
            </button>
        </div>
    </ng-template>
</p-dialog>